import "./App.scss";
import { Fragment, useEffect } from "react";
import ContextProvider from "./context/menucontext";
import { Route, Routes, useLocation } from "react-router-dom";
import { routesData } from "./utils/routingData";
import ErrorPage from "./pages/errorpage/ErrorPage";

function App() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ContextProvider>
      <div className="App">
        <Routes>
          {routesData.map((data) => {
            return (
              <Fragment key={data.id}>
                <Route path={data.path} element={data.component} />                
              </Fragment>
            );
          })}
          <Route path="/*" element={<ErrorPage />} />
        </Routes>
      </div>
    </ContextProvider>
  );
}

export default App;